module.exports = __webpack_public_path__ + "img/touch_of_midas.3156286d.png";